import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  iconClassName?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, icon: Icon, iconClassName, action }: EmptyStateProps) {
  return (
    <div className="text-center py-16">
      {Icon && (
        <div
          className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto ${iconClassName || 'bg-muted/50'}`}
        >
          <Icon className="h-6 w-6" />
        </div>
      )}
      <p className="text-lg mt-4 font-medium">{title}</p>
      {description && <p className="text-sm text-muted-foreground mt-2">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
